import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EneterVOWDComment } from '../../_models/enter-vowd-comment';
import { AddVOWDComment } from '../../_models/add-vowd-comment';
import { GlobalDataService } from '../../_shared';
import { ModalPopupAlertComponent } from '../../_shared/modal-popup-alert/modal-popup-alert.component';
import { LoginUser } from '../../_models';

@Component({
  standalone: false,
  selector: 'app-vowd-comment',
  templateUrl: './vowd-comment.component.html',
  styleUrls: ['./vowd-comment.component.css']
})
export class VowdCommentComponent implements OnInit {
   public vowdCommentList: EneterVOWDComment[] = [];
   addVowdComment : AddVOWDComment[] =[];
   ModalHeader :string ="VOWD Comment";
   user: LoginUser = new LoginUser;
   IsCommentNullorEmpty: boolean = false;
  constructor(
    public activeModal: NgbActiveModal,private gd :GlobalDataService,private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.user = this.gd.getUserData();    
    this.checkComment();
  }

  openAlertModal(strmsg:any) {
    const modalRef = this.modalService.open(ModalPopupAlertComponent);
    modalRef.componentInstance.strText = strmsg;
    modalRef.result.then((result) => {
    }, (reason) => {
    });   
  }
  
  submit(){   
        
        this.vowdCommentList.forEach(element => {
        
          this.addVowdComment.push(
            {                      
              SupplierAB : element.supplierab,
              ObjectAccount: element.objectaccount,
              Comment: element.Comment,
              CurMonthVOWD: element.CurAmt,
              Month: this.gd.monthNames[new Date().getMonth()]  +"-"+ new Date().getFullYear(),
              PrevMonthVOWD: element.PrevAmt,
              CreatedBy :this.user.Employee_CAI,
              UpdatedBy :this.user.Employee_CAI,
            })     
          
      });
      this.activeModal.close(this.addVowdComment);
     
    
}

checkComment(){ 
 
    if(this.vowdCommentList.some(item => item.Comment == null || item.Comment == '')){
         this.IsCommentNullorEmpty = true;
      
    }else{
      this.IsCommentNullorEmpty = false;
    }
  
}

closeModal() {
  this.activeModal.dismiss(undefined);
}

}
